/**
 * PM Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WooProductImage } from './wooProductImage';
import { BrandedNumber } from './brandedNumber';
import { WooAttribute } from './wooAttribute';


export interface Variation { 
    _id: object;
    product: object;
    sku: string;
    regular_price: Array<BrandedNumber>;
    sale_price: Array<BrandedNumber>;
    price_offset: number;
    stock_status: string;
    status: Variation.StatusEnum;
    description: string;
    image: WooProductImage | null;
    attributes: Array<WooAttribute>;
    sortOrder: number;
    isDeleted: boolean;
    deletedAt: string | null;
}
export namespace Variation {
    export const StatusEnum = {
        draft: 'draft',
        pending: 'pending',
        private: 'private',
        publish: 'publish'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


